/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type TotalOrdersQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.TotalOrdersFilter>;
}>;

export type TotalOrdersQuery = {
	__typename?: "Query";
	totalOrders: {
		__typename?: "TotalOrdersResult";
		fiats: Array<{
			__typename?: "AmountWithFiat";
			fiatId: string;
			amount: { __typename?: "CurrencyAmount"; value: string };
		}>;
	};
};

export const TotalOrdersDocument = gql`
	query totalOrders($filter: TotalOrdersFilter) {
		totalOrders(filter: $filter) {
			fiats {
				fiatId
				amount {
					value
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class TotalOrdersGQLService extends Apollo.Query<TotalOrdersQuery, TotalOrdersQueryVariables> {
	document = TotalOrdersDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
